import {
    AzureStorageLinkedService,
    Collection,
    Dataset,
    IModel,
    IAttribute,
    LinkedService,
    ModelConstants
} from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';
import { AzureBatchLinkedService } from '../linkedservice//azure-batch.linkedservice';

import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { ReferenceObjectParameters } from 'app/model/pipeline/reference-object-parameters';
import { format } from 'app/shared/utils/string.util';
import { Copier } from 'app/model/base/copier';

@Metamodel.model({
    name: ModelConstants.customActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.CustomLabel),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.CustomLabel)
    ],
    referable: true
})
export class CustomActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly COMMAND: IAttribute;

    @Metamodel.attribute({
        display: __IS_FABRIC_DPE__ ? stringResources.CustomActivityAzureBatchConnection : stringResources.CustomActivityAzureBatchLinkedService,
        constraint: {
            required: true
        },
        reference: true,
        type: AzureBatchLinkedService.MODEL
    })
    public linkedService?: AzureBatchLinkedService;

    @Metamodel.attribute({
        display: stringResources.CustomActivitySettingsStagingConnection,
        reference: true,
        type: AzureStorageLinkedService.MODEL
    })
    public stagingLinkedService?: AzureStorageLinkedService;

    // TODO: support expression
    @Metamodel.attribute({
        display: stringResources.ModelName_Command,
        constraint: {
            required: true
        },
        association: 'COMMAND',
        templatable: true
    })
    public command: string;

    @Metamodel.attribute({
        display: __IS_FABRIC_DPE__ ? stringResources.CustomActivitySettingsResourceConnection : stringResources.CustomActivitySettingsResourceLinkedService,
        constraint: {
            required: __IS_FABRIC_DPE__ ? true : ['folderPath']
        },
        reference: true,
        type: AzureStorageLinkedService.MODEL
    })
    public resourceLinkedService?: AzureStorageLinkedService;

    // TODO: support expression
    @Metamodel.attribute({
        display: stringResources.FolderPath_Label,
        constraint: {
            required: __IS_FABRIC_DPE__ ? false : ['resourceLinkedService']
        },
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: stringResources.CustomActivitySettingsReferenceObjects,
        reference: true,
        collection: Collection.Array
    })
    public referenceObjects: Array<LinkedService | Dataset | undefined> = [];

    @Metamodel.attribute({
        display: stringResources.CustomActivitySettingsExtendedProperties,
        constraint: {
            validator: createParameterConfigurationValidator(true)
        }
    })
    public extendedProperties?: ParameterConfig[];

    /**
     * Parameter value for referenced objects.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false
        }
    })
    public referenceObjectsParameters: ReferenceObjectParameters[] = [];

    @Metamodel.attribute({
        display: stringResources.CustomActivitySettingsRetentionPeriod,
        constraint: {
            minimum: 0
        }
    })
    public retentionTimeInDays: number;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    public onActivityCloned(clonedActivity: CustomActivity, context: { inlineDataset?: boolean }): void {
        if (__IS_FABRIC_DPE__) {
            if (this.linkedService?.parameterized) {
                clonedActivity.linkedService = Copier.clone(
                    context,
                    [this.linkedService],
                    undefined,
                    true
                )[0] as AzureBatchLinkedService;
            }
            if (this.resourceLinkedService?.parameterized) {
                clonedActivity.resourceLinkedService = Copier.clone(
                    context,
                    [this.resourceLinkedService],
                    undefined,
                    true
                )[0] as AzureStorageLinkedService;
            }
        }
    }
}
